import { Component } from 'react';
import { connect } from 'react-redux';
import {
    requestLoginCheck,
} from '../../store/WriteClass';

class LoginCheck extends Component {

    constructor(props) {
        super(props);
        this.interval = null;
    }

    componentWillReceiveProps(nextProps){
        if (this.props.loggedIn !== nextProps.loggedIn) {
            // loggedIn status changed
            if (nextProps.loggedIn) {
                this.startPolling();
            } else {
                this.stopPolling();
            }
        }
    }

    componentWillUnmount() {
        this.stopPolling();
    }

    startPolling() {
        if (this.interval) {
            // remove timer if it is somehow hanging around
            this.stopPolling();
        }
        this.interval = setInterval(this.props.requestLoginCheck, 1000*60*5);  // every 5 minutes
    }

    stopPolling() {
        clearInterval(this.interval);
    }

    render() {
        return null;
    }
}

const mapStateToProps = (state) => ({
    loggedIn: state.write_class.loggedIn,
});


const mapDispatchToProps = (dispatch) => ({
    requestLoginCheck: () => dispatch(requestLoginCheck()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginCheck);


// WEBPACK FOOTER //
// ./src/components/loginCheck/index.jsx